import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";
import moment from "moment";
import './style.scss';
import './reviewGroupReviews.scss';

import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";
import { Button } from "shards-react";
import FeatherIcon from 'feather-icons-react';

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ product }) => ({ getProductGroupList: product.getProductGroupList }))
@inject(({ review }) => ({ getReviewList: review.getReviewList }))
@observer
class ReviewGroupReviews extends Component {

  @observable teamUser = {};
  @observable store = {};
  @observable isLoading = true;

  @observable groupId = '';
  @observable group = null;       // { _id, name, ... }
  @observable products = [];      // 그룹에 속한 상품들
  @observable repProduct = null;  // 리뷰 조회용 대표 상품 (share 그룹 자동 통합 트리거)
  @observable list = {};          // getReviewList 결과
  @observable listParams = { page: 1, limit: 20 };
  @observable notFound = false;

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if(!this._inited && this.props.isLogin && !prevProps.isLogin) {
      this.init();
    }
  }

  @action
  init = async () => {
    if(!this.props.isLogin || this._inited) return;
    this._inited = true;

    this.teamUser = this.props.me;
    this.store = this.props.me.store ? this.props.me.store : {};

    const search = (this.props.location && this.props.location.search) || window.location.search;
    const params = new URLSearchParams(search);
    this.groupId = params.get('group_id') || '';
    const nameFromQuery = params.get('name') || '';

    if(!this.groupId) {
      this.notFound = true;
      this.isLoading = false;
      return;
    }

    await this.loadGroup(nameFromQuery);
    if(this.group && this.repProduct) {
      await this.getReviews();
    }
    this.isLoading = false;
  };

  loadGroup = async (nameFromQuery) => {
    const res = await this.props.getProductGroupList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      page: 1, limit: 200
    });
    const docs = (res && res.docs) || [];
    const grp = _.find(docs, d => String(d._id) === String(this.groupId));
    if(grp) {
      this.group = grp;
      this.products = grp.product_ids || grp.products || [];
      this.repProduct = this.products.length > 0 ? this.products[0] : null;
    }
    else {
      this.notFound = true;
      if(nameFromQuery) this.group = { name: nameFromQuery, _id: this.groupId };
    }
  };

  // 상품 _id 형식: {platform}_{store_id}_{[shopNo_]}{platformProductId}
  parseProductId = (productId) => {
    const parts = String(productId || '').split('_');
    return {
      platform: parts[0] || 'cafe24',
      platformProductId: parts.length ? parts[parts.length - 1] : ''
    };
  };

  getReviews = async (page) => {
    if(!this.repProduct) { this.list = { docs: [], totalDocs: 0 }; return; }
    this.isLoading = true;
    if(page) this.listParams.page = page;

    const parsed = this.parseProductId(this.repProduct._id);
    const platformProductId = this.repProduct.platformProductId || parsed.platformProductId;
    const platform = this.repProduct.platform || parsed.platform;

    const res = await this.props.getReviewList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      platformProductId: platformProductId,
      platform: platform,
      displayStatus: 100,       // 100 = 전체 (게시중/대기/숨김 포함)
      page: this.listParams.page,
      limit: this.listParams.limit,
      isPopulateProductReply: true
    });

    if(res && res.docs) {
      _.map(res.docs, function(row) { row.product = row.product_id; return row; });
      this.list = res;
    }
    else {
      this.list = { docs: [], totalDocs: 0 };
    }
    this.isLoading = false;
  };

  goBack = () => {
    if(this.props.history) this.props.history.push('/reviewGroup');
    else window.location.href = '/reviewGroup';
  };

  buildProductUrl = (product) => {
    if(!product) return null;
    const store = this.store || {};
    let domain = store.domain || (store.platformId ? store.platformId + '.cafe24.com' : '');
    if(!domain) return null;
    let platformProductId = product.platformProductId;
    if(!platformProductId && product._id) platformProductId = this.parseProductId(product._id).platformProductId;
    if(!platformProductId) return null;
    const name = product.productName || platformProductId;
    const base = /^https?:\/\//.test(domain) ? domain : '//' + domain;
    return base + '/product/' + encodeURIComponent(name) + '/' + platformProductId + '/';
  };

  openProductPage = (product) => {
    const url = this.buildProductUrl(product);
    if(url) window.open(url, '_blank', 'noopener');
  };

  // goodsPt(0~100) -> 별점 1~5
  starCount = (goodsPt) => {
    const pt = Number(goodsPt) || 0;
    if(pt <= 20) return 1;
    if(pt <= 40) return 2;
    if(pt <= 60) return 3;
    if(pt <= 80) return 4;
    return 5;
  };

  renderStars = (goodsPt) => {
    const n = this.starCount(goodsPt);
    return (
      <span className="rgr-stars" title={n + '점'}>
        {[1, 2, 3, 4, 5].map(i => (
          <span key={i} className={i <= n ? 'is-on' : ''}>★</span>
        ))}
      </span>
    );
  };

  statusLabel = (displayStatus) => {
    switch(parseInt(displayStatus)) {
      case 2:  return { txt: '게시 중', cls: 'is-on' };
      case 1:  return { txt: '게시 대기', cls: 'is-wait' };
      case 3:  return { txt: '작성 후 대기', cls: 'is-wait' };
      case 90: return { txt: '숨김', cls: 'is-hidden' };
      default: return { txt: String(displayStatus), cls: '' };
    }
  };

  // 리뷰 이미지 URL 배열 (thumbs > images > platformImages 우선순위)
  getReviewImages = (item) => {
    if(item.thumbs && item.thumbs.length) {
      return item.thumbs.map(t => typeof t === 'object' ? t.url : (t + '/thumba')).filter(Boolean);
    }
    if(item.images && item.images.length) {
      return item.images.map(im => typeof im === 'object' ? im.url : (im + '/thumba')).filter(Boolean);
    }
    if(item.platformImages && item.platformImages.length) {
      return item.platformImages.map(p => (p && p.path) ? p.path : null).filter(Boolean);
    }
    return [];
  };

  renderPagination = () => {
    const list = this.list || {};
    if(!list.totalPages || list.totalPages <= 1) return null;
    const curPageNum = list.page;
    const totalPages = list.totalPages;
    const startNum = (parseInt((curPageNum - 1) / 10) * 10) + 1;
    const endNum = startNum + 9 < totalPages ? startNum + 9 : totalPages;
    const items = [];
    for(let i = startNum; i <= endNum; i++) {
      items.push(<li key={i} className={i === curPageNum ? 'on' : ''} onClick={() => this.getReviews(i)}>{i}</li>);
    }
    return (
      <div className="rgr-pagination">
        <ul>
          {curPageNum !== 1 ? <li onClick={() => this.getReviews(1)}><FeatherIcon icon="chevrons-left" size="14"/></li> : null}
          {startNum - 1 > 0 ? <li onClick={() => this.getReviews(startNum - 1)}><FeatherIcon icon="chevron-left" size="14"/></li> : null}
          {items}
          {endNum !== totalPages ? <li onClick={() => this.getReviews(startNum + 10)}><FeatherIcon icon="chevron-right" size="14"/></li> : null}
          {curPageNum !== totalPages ? <li onClick={() => this.getReviews(totalPages)}><FeatherIcon icon="chevrons-right" size="14"/></li> : null}
        </ul>
      </div>
    );
  };

  renderReviewCard = (item, i) => {
    const product = item.product_id || item.product;
    const productUrl = this.buildProductUrl(product);
    const productName = item.orderProductName || (product && product.productName) || '제품 정보 없음';
    const productThumb = product && product.image ? product.image : '';
    const images = this.getReviewImages(item);
    const status = this.statusLabel(item.displayStatus);
    const writer = item.writerName || '익명';
    const writerType = item.isAdmin ? '관리자' : (item.isMember ? '회원' : '비회원');
    const hasReply = item.comment && item.comment.content;

    return (
      <div className="rgr-review-card" key={item._id || i}>
        <div className="rgr-review-card__top">
          <div className="rgr-review-card__writer">
            <span className="rgr-review-card__name">{writer}</span>
            <span className={`rgr-badge${item.isAdmin ? ' rgr-badge--admin' : ''}`}>{writerType}</span>
            {this.renderStars(item.goodsPt)}
          </div>
          <div className="rgr-review-card__right">
            <span className={`rgr-status ${status.cls}`}>{status.txt}</span>
            <span className="rgr-review-card__date">{item.displayAt ? moment(item.displayAt).format('YYYY-MM-DD') : ''}</span>
          </div>
        </div>

        {product && (
          <div className={`rgr-review-card__product${productUrl ? ' is-clickable' : ''}`}
               onClick={productUrl ? () => this.openProductPage(product) : undefined}
               title={productUrl ? '상품 페이지 새 탭으로 열기' : undefined}>
            {productThumb ? <img src={productThumb} alt=""/> : <span className="rgr-review-card__product-noimg"><FeatherIcon icon="image" size="14"/></span>}
            <span className="rgr-review-card__product-name">{productName}</span>
            {item.orderProductOptions ? <span className="rgr-review-card__product-opt">{item.orderProductOptions}</span> : null}
          </div>
        )}

        <div className="rgr-review-card__content"
             dangerouslySetInnerHTML={{ __html: item.contents ? item.contents.replace(/\\n|\n/g, '<br>') : '' }} />

        {images.length > 0 && (
          <div className="rgr-review-card__images">
            {images.map((src, j) => (
              <a key={j} href={src} target="_blank" rel="noopener noreferrer" className="rgr-review-card__image">
                <img src={src} alt=""/>
              </a>
            ))}
          </div>
        )}

        {hasReply ? (
          <div className="rgr-review-card__reply">
            <FeatherIcon icon="corner-down-right" size="14"/>
            <div className="rgr-review-card__reply-text"
                 dangerouslySetInnerHTML={{ __html: item.comment.content.replace(/\\n|\n/g, '<br>') }} />
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    const docs = (this.list && this.list.docs) || [];
    const total = (this.list && this.list.totalDocs) || 0;
    const groupName = this.group ? this.group.name : '';

    return (
      <div className="main-content rgr-page">
        <PageTitle title="그룹 리뷰" subtitle="리뷰/답글" className="mb-4"/>

        <div className="widget-box">
          <div className="rgr-header">
            <Button size="sm" theme="light" className="rgr-header__back" onClick={() => this.goBack()}>
              <FeatherIcon icon="arrow-left" size="14"/> 리뷰 그룹
            </Button>
            <div className="rgr-header__info">
              <FeatherIcon icon="layers" size="16" style={{color: '#6B7280'}}/>
              <h3 className="rgr-header__title">{groupName || '그룹'}</h3>
              <span className="src-chip">상품 {this.products.length}개</span>
              <span className="src-chip rgr-chip--review">리뷰 {total}개</span>
            </div>
          </div>

          {this.products.length > 0 && (
            <div className="rgr-group-products">
              {this.products.map(p => {
                const thumb = p.images && p.images.s_1 ? p.images.s_1 : '';
                const url = this.buildProductUrl(p);
                return (
                  <div key={p._id}
                       className={`rgr-group-products__item${url ? ' is-clickable' : ''}`}
                       onClick={url ? () => this.openProductPage(p) : undefined}
                       title={url ? '상품 페이지 새 탭으로 열기' : undefined}>
                    {thumb ? <img src={thumb} alt=""/> : <span className="rgr-group-products__noimg"><FeatherIcon icon="image" size="16"/></span>}
                    {p.productName ? <span className="rgr-group-products__name">{p.productName}</span> : null}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* 본문 */}
        {this.notFound && !this.group ? (
          <div className="rgr-empty">
            <FeatherIcon icon="alert-circle" size="40"/>
            <div className="rgr-empty__title">그룹을 찾을 수 없습니다</div>
            <div className="rgr-empty__desc">리뷰 그룹 페이지에서 다시 시도해주세요.</div>
          </div>
        ) : this.products.length === 0 ? (
          <div className="rgr-empty">
            <FeatherIcon icon="package" size="40"/>
            <div className="rgr-empty__title">이 그룹에 등록된 상품이 없습니다</div>
            <div className="rgr-empty__desc">리뷰 그룹 페이지에서 상품을 추가해주세요.</div>
          </div>
        ) : !this.isLoading && docs.length === 0 ? (
          <div className="rgr-empty">
            <FeatherIcon icon="message-square" size="40"/>
            <div className="rgr-empty__title">조회된 리뷰가 없습니다</div>
            <div className="rgr-empty__desc">그룹에 속한 상품에 등록된 리뷰가 아직 없습니다.</div>
          </div>
        ) : (
          <div className="rgr-review-list">
            {docs.map((item, i) => this.renderReviewCard(item, i))}
            {this.renderPagination()}
          </div>
        )}

        <ModalLoading isLoading={this.isLoading} />
      </div>
    );
  }
}

export default ReviewGroupReviews;
